import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../../_helpers/fetch-wrapper";
import { IMAGE } from "../../constants/endpoints";

export const removeImage = createAsyncThunk(
    'image/remove',
    async (id: number) => {
        await fetchWrapper.delete(IMAGE, id);
    }
);